// extracted by mini-css-extract-plugin
module.exports = {"companyLogo":"styles_companyLogo__29dfH","uploadable":"styles_uploadable__2GCGQ"};